import React from 'react'

function Skills() {
  return (
    <>
        <div className='skills'>
            <div className='container'>
                <div className='all_skills'>
                    <img src="https://img.icons8.com/fluency/96/null/python.png" alt='logo'/>
                    <img src="https://img.icons8.com/color/96/null/javascript--v1.png" alt='logo'/>
                    <img src="https://img.icons8.com/external-others-iconmarket/64/null/external-cpp-file-types-others-iconmarket-2.png" alt='logo'  id='CPP'/>
                    <img src="https://img.icons8.com/color/96/null/mongodb.png" alt='logo'/>
                    <img src="https://img.icons8.com/ios/100/000000/django.png" alt='logo' id='Django'/>
                    <img src="https://img.icons8.com/color/96/null/react-native.png" alt='logo'/>
                    <img src="https://img.icons8.com/color/96/null/mysql-logo.png" alt='logo'/>
                </div>
            </div>
        </div>
    </>
  )
}

export default Skills